export default {
    attachmentsReceived: '{{documentsCount}} Attachment(s) Received',
    disputeAmount: 'Dispute Amount',
    disputeDate: 'Dispute Date',
    disputeDetails: 'Dispute Details',
    disputeHistory: 'Dispute History',
    disputeID: 'Dispute ID',
    documentsReceived: 'Documents Received',
    originalDisputeAmount: 'Original Dispute Amount',
    originalDisputeID: 'Original Dispute ID',
    originalDisputeReason: 'Original Dispute Reason',
    originalTransaction: 'Original Transaction',
    recommendedDocumentation: '<0>Recommended Documentation</0>: {{disputeReason}}'
};
//# sourceMappingURL=disputeDetails.js.map